<template>
  <div class="wrraper custom_card" style="direction: ltr;">
    <!-- Start Breadcrumb -->
    <Breadcrumb :items="items" />

    <!-- End Breadcrumb -->
    <MainLoader v-if="loading"></MainLoader>
    <div v-else>
      <div class="portfolio_page">
        <!-- Start Main Header  -->
        <MainPortfolioHeaderSection
          :firstColor="firstColor"
          :Project="projectData"
        />
        <!-- End Main Header  -->

        <!-- Start What App Section -->
        <div class="what_section">
          <div class="container-xl">
            <div class="row">
              <!-- <app-images-card   class="col-lg-6  col-sm-12" :image1="projectData" :image2="appImages[1].src"/> -->
              <div class="col-lg-6 col-md-12">
                <img :src="projectData.about_image" class="image_section" />
              </div>
              <div class="col-lg-6 col-sm-12 text_section">
                <h3>ماهو {{ Project.name }}</h3>
                <p>{{ projectData.about_project }}</p>
              </div>
            </div>
          </div>
        </div>
        <!-- End What App Section -->

        <!-- Start Some Features Section -->
        <div class="container-xl">
          <div class="row">
            <div class="some_features">
              <div class="col-lg-4 col-sm-12">
                <featuresCard
                  :hasButton="false"
                  :description="projectData.feature_description"
                  :title="projectData.feature_title"
                  :features="projectData.main_features"
                  :hasButtion="false"
                  :mainColor="firstColor"
                />
              </div>
              <div class="col-lg-8 col-sm-12">
                <div class="images_section">
                  <img
                    v-for="image in projectData.feature_images"
                    :key="image"
                    :src="image.media"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- End Some Features Section -->

        <!-- Start Facts Section-->
        <div class="some_facts_section custom_section">
          <!-- <img  src="@/assets/img/home/circle.png" class="image_inside"/> -->
          <div class="container-xl">
            <p>{{ $t("TITLES.ourSuccess") }}</p>
            <h2>{{ $t("TITLES.facts") }}{{ projectData.name }}</h2>
            <div class="row justify-content-center">
              <div class="col-lg-3 col-md-4 col-sm-6 fact_container">
                <p class="value_box">
                  {{ projectData.founded_in }}
                </p>

                <p></p>
                <p class="key_box">
                  تم أنشائه
                </p>
              </div>
              <div class="col-lg-3 col-md-4 col-sm-6 fact_container">
                <p class="value_box">
                  {{ projectData.location }}
                </p>

                <p></p>
                <p class="key_box">
                  الدولة
                </p>
              </div>
              <div class="col-lg-3 col-md-4 col-sm-6 fact_container">
                <p class="value_box">
                  {{ projectData.downloads }}
                </p>

                <p></p>
                <p class="key_box">
                  عدد مرات التحميل
                </p>
              </div>
              <div class="col-lg-3 col-md-4 col-sm-6 fact_container">
                <p class="value_box">
                  {{ projectData.ratings }}
                </p>

                <p></p>
                <p class="key_box">
                  التقييم
                </p>
              </div>
            </div>
          </div>
        </div>
        <!-- End  Facts Section -->

        <!-- Start Splash Screens -->
        <screens-section :images="projectData" />
        <!-- End Splash Screens -->

        <!-- Start What We Did Setion -->
        <div class="what_we_did custom_section">
          <div class="container-xl">
            <div class="text_section">
              <h2>ماذا فعلنا في المشروع</h2>
              <p>{{ projectData.project_done_description }}</p>
            </div>
            <div class="row">
              <div class="app_images">
                <div
                  class="col-lg-3 col-md-6"
                  v-for="image in projectData.project_done_images"
                  :key="image"
                >
                  <img :src="image.media" class="single_image" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- End What We Did Setion -->

        <!-- Start Why This App  -->
        <why-app-section class="" :featuresData="project" />
        <!-- End Why This App -->

        <!-- Start Facts Section-->
        <div class="some_facts_section tools_section custom_section">
          <div class="container-xl">
            <h2>
              الادوات والتقنيات
            </h2>
            <div class="row">
              <div
                class="col-lg-2 col-md-4 col-sm-6 fact_container tool_container"
                v-for="tool in projectData.tools"
                :key="tool.id"
              >
                <img :src="tool.image" />
                <p class="key_box">
                  {{ tool.title }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <!-- End  Facts Section -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: ["id"],
  components: {
    MainPortfolioHeaderSection: () =>
      import("@/components/Project/MainPortfolioHeaderSection.vue"),
    ScreensSection: () => import("@/components/Project/ScreensSection.vue"),
    AppImagesCard: () => import("@/components/Project/AppImageCard.vue"),
    WhyAppSection: () => import("@/components/Project/WhyAppSection.vue"),
    featuresCard: () => import("@/components/Project/featuresCard.vue"),
  },
  data() {
    return {
      firstColor: null,
      secondColor: null,
      thirdColor: null,
      images: {
        section1: [
          {
            id: 1,
            src: require("@/assets/images/portfolio/frontimg1.png"),
          },
          {
            id: 2,
            src: require("@/assets/images/portfolio/mainimage1.png"),
          },
          {
            id: 3,
            src: require("@/assets/images/portfolio/backone.png"),
          },
        ],
        section2: [
          {
            id: 1,
            src: require("@/assets/images/portfolio/frontimage2.png"),
          },
          {
            id: 2,
            src: require("@/assets/images/portfolio/secondimg2.png"),
          },
          {
            id: 3,
            src: require("@/assets/images/portfolio/mainimg1.png"),
          },
        ],
      },
      Project: {
        subtitle: "App Development",
        name: "Outfit",
        type: "E-Commerce App",
        category: " - a Fashion",
        description:
          "Outfit is an ecommerce marketplace that offers buying and selling functionalities to its customers. the best part about this platform is that users can view the product they are looking for to get the exact size and shape. outfit aims to solve all the issues a user may face while making a purchase.",
        text:
          "Checkout how Creative System helped Outfit establish a successful ecommerce marketplace in the digital world.",
        image: require("@/assets/images/portfolio/mainHeader.png"),
      },
      appImages: [
        {
          id: 1,
          src: require("@/assets/images/portfolio/iPhone (1).png"),
        },
        {
          id: 2,
          src: require("@/assets/images/portfolio/iPhone.png"),
        },
        {
          id: 3,
          src: require("@/assets/images/portfolio/iPhone (1).png"),
        },
        {
          id: 4,
          src: require("@/assets/images/portfolio/iPhone.png"),
        },
      ],
      facts: [
        {
          id: 1,
          value: 2022,
          key: "Founded In",
        },
        {
          id: 2,
          value: "Egypt",
          key: "Location",
        },
        {
          id: 3,
          value: "3K",
          key: "Downloads",
        },
        {
          id: 4,
          value: 4.2,
          key: "Ratings",
        },
      ],
      tools: [
        {
          id: 1,
          name: "Adobe XD",
          image: require("@/assets/images/portfolio/xd.png"),
        },
        {
          id: 2,
          name: "Adobe XD",
          image: require("@/assets/images/portfolio/xd.png"),
        },
        {
          id: 3,
          name: "Adobe XD",
          image: require("@/assets/images/portfolio/xd.png"),
        },
        {
          id: 4,
          name: "Adobe XD",
          image: require("@/assets/images/portfolio/xd.png"),
        },
        {
          id: 5,
          name: "Adobe XD",
          image: require("@/assets/images/portfolio/xd.png"),
        },
        {
          id: 6,
          name: "Adobe XD",
          image: require("@/assets/images/portfolio/xd.png"),
        },
      ],
      whySectionData: {
        text:
          " 81% of smartphone users have made a purchase online using their mobile device in the last 6 months. looking at the number so people making purchases from an ecommerce platform we create a solution that offers:",
        features: [
          {
            id: 1,
            text: "Improved Visitors Engagement",
          },
          {
            id: 2,
            text: "Improved Visitors Engagement",
          },
          {
            id: 3,
            text: "Improved Visitors Engagement",
          },
          {
            id: 4,
            text: "Improved Visitors Engagement",
          },
        ],
        appImages: [
          {
            id: 1,
            src: require("@/assets/images/portfolio/whyImage1.png"),
          },
          {
            id: 2,
            src: require("@/assets/images/portfolio/whyImage2.png"),
          },
          {
            id: 3,
            src: require("@/assets/images/portfolio/whyImage3.png"),
          },
        ],
      },
      FirstViewSomeFeaturesSection: {
        image: require("@/assets/images/portfolio/Group 17825.png"),
        colorTheme: "#ADECE3",
        title: "Ecommerce App Solution",
        subTitle: "Some Features Of Our",
        text:
          " 81% of smartphone users have made a purchase online using their mobile device in the last 6 months. looking at the number so people making purchases from an ecommerce platform we create a solution that offers:",
        features: [
          {
            id: 1,
            text: "Improved Visitors Engagement",
          },
          {
            id: 2,
            text: "Improved Visitors Engagement",
          },
          {
            id: 3,
            text: "Improved Visitors Engagement",
          },
          {
            id: 4,
            text: "Improved Visitors Engagement",
          },
          {
            id: 5,
            text: "Improved Visitors Engagement",
          },
          {
            id: 6,
            text: "Improved Visitors Engagement",
          },
        ],
      },
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.projects.title"),
          disabled: false,
          href: "/projects",
        },
        {
          text: this.$t("breadcrumb.projects.all"),
          disabled: true,
          href: "",
        },
      ],

      //Data
      allData: null,
      products_details: null,

      c1: undefined,
      c2: undefined, // ========== Loding
      loading: false,
      projectData: null,

      // ========== Table
    };
  },

  watch: {
    [`paginations.current_page`]() {},
  },

  computed: {
    ...mapGetters({
      lang: "lang_module/lang",
    }),
    year() {
      return this.projectData.created_at.slice(0, 4);
    },
  },

  methods: {
    getData() {
      this.loading = true;
      this.axios({
        method: "GET",
        url: `project/${this.id}`,
      })
        .then((res) => {
          this.projectData = res.data.data;
          (this.firstColor = this.projectData.backgrounds[0].bg),
            (this.secondColor = this.projectData.backgrounds[1].bg),
            (this.thirdColor = this.projectData.backgrounds[2].bg),
            (this.loading = false);
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
          this.loading = false;
          this.$router.push({ path: "/projects" });
        });
    },
  },

  // ======= hooks
  mounted() {
    // this.c1 = this.$refs.c1;
    // this.c2 = this.$refs.c2;
    this.getData();
    // this.getProductDetails(0);
  },
};
</script>

<style lang="scss">
$maincolor: v-bind(firstColor);
$secondcolor: v-bind(secondColor);
$thirdColor: v-bind(thirdColor);
// General section styling
.custom_section {
  position: relative;
  width: 100%;
  background: linear-gradient(to right, $maincolor, $secondcolor, $thirdColor);
  min-height: 470px;
  padding-block-start: 50px;
  h2 {
    @include homeSecondTitle;
    font-size: 54px;
    color: #fff;
    line-height: 75px;
  }
  p {
    @include homeFirstTitle;
    color: #fff;
  }
}
// START STYLING MAIN SECTIONS
.portfolio_page {
  .main_header {
    @include flexSpaceBetweenAlignment;
    min-height: 400px;
    h6 {
      font-size: 20px;
    }
    h2 {
      @include homeSecondTitle;
      font-weight: 900;
      font-size: 50px;
      span {
        @include homeSecondTitle;
        color: $maincolor;
        font-size: 50px;
      }
    }
    p {
      font-size: 17px;
      color: black;
      font-style: italic;
    }
  }
  .what_section {
    background: linear-gradient(
      104deg,
      $maincolor,
      $secondcolor 51%,
      $thirdColor 100%
    );
    min-height: 400px;
    width: 100%;
    max-height: 540px;
    position: relative;
    @include flexSpaceBetweenAlignment;
    .app_image_card {
      top: -95px !important;
      position: relative;
    }
    .image_inside {
      bottom: -200px;
      right: 0;
    }
    .image_section {
      top: -95px !important;
      position: relative;
      width: 95%;
      max-width: 450px;
    }
  }
  .text_section {
    @include verticalFlexStartAlignment;
    padding-inline-end: 10px;
    h3 {
      // font-family: $medium_font;
      font-size: 28px;
      letter-spacing: 1.5px;
      color: #fff;
      font-weight: 600;
    }
    p {
      color: var(--white_clr);
      font-size: 16px;
      // font-family: $regular_font;
      line-height: 32px;
    }
  }
  .some_features {
    min-height: 750px;
    width: 100%;
    position: relative;
    z-index: 6;
    @include flexSpaceBetweenAlignment;
    .images_section {
      @include flexSpaceBetweenAlignment;
      column-gap: 10px;
      position: relative;
      img {
        height: 610px;
        min-width: 300px;
        width: 31%;
        position: relative;
        display: inline-block;
      }
      img:nth-of-type(2) {
        bottom: 200px !important;
      }
      &::before {
        content: "";
        width: 650px;
        height: 650px;
        background: linear-gradient($maincolor, $secondcolor, $thirdColor);
        border-radius: 50%;
        position: absolute;
        z-index: -1;
        left: 18%;
      }
    }
  }
  .what_we_did {
    max-height: 670px;
    p {
      font-size: 16px;
      margin-block-end: 25px;
    }
    .app_images {
      @include flexSpaceBetweenAlignment;
      column-gap: 15px;
      margin-block-start: 20px;
      > * {
        padding: 0px !important;
      }
      .single_image {
        display: inline-block;
        width: 80%;
        min-width: 285px;
        height: 600px;
      }
    }
    .image_inside {
      top: -100px;
      right: -100px;
    }
  }
  .panner_section {
    height: 300px;
  }
  .some_facts_section {
    min-height: 600px;
    h2 {
      width: 50%;
      margin-block-end: 40px;
    }
    p {
      margin-bottom: 0;
    }
    .fact_container {
      display: flex;
      flex-direction: column;
      justify-content: center;
      flex-wrap: wrap;
      min-height: 270px;
      border-right: 1px solid #69baa2;
      .value_box,
      .key_box {
        text-align: center;
        width: 100%;
        margin-bottom: 0px;
      }
      .value_box {
        font-size: 55px;
        margin-block-end: 15px;
      }
    }
    .fact_container:last-of-type {
      border-right-color: #00000000;
    }
    .image_inside {
      top: -100px;
      right: -100px;
    }
  }
  .services_provided {
    padding-block-start: 0;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    h2 {
      margin-block-end: 30px;
    }
  }
  .tools_section {
    background: none;
    min-height: 550px;
    margin-block-start: 100px;
    p:first-of-type {
      color: $maincolor;
    }
    * {
      color: black;
    }
    p {
      width: 40%;
      font-size: 15px;
    }
    .tool_container {
      margin-block-start: 40px;
      align-items: center;
      min-height: 150px;
      img {
        width: 80px;
        display: block;
      }
      p {
        margin-block-start: 15px;
        font-size: 14px;
        color: black;
      }
    }
  }
  .Why_this_app {
    background: none;
    padding-block-start: 250px;
    @include verticalFlexStartAlignment;
    min-height: 800px;
    padding-block-end: 60px;
  }
}
.image_inside {
  z-index: 5;
  width: 400px;
  position: absolute;
}
</style>
